
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSortingArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 22,
  width: 16,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "var(--theme-primary, #810ea9)"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 9.25H6a.74.74 0 0 1-.69-.46.75.75 0 0 1 .16-.82l6-6a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 .16.82.74.74 0 0 1-.69.46ZM12 22.25a.74.74 0 0 1-.53-.22l-6-6a.75.75 0 0 1-.16-.82.74.74 0 0 1 .69-.46h12a.74.74 0 0 1 .69.46.75.75 0 0 1-.16.82l-6 6a.74.74 0 0 1-.53.22Z"
})));

      const __svgRaw = "<svg height=\"22\" width=\"16\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"var(--theme-primary, #810ea9)\">\r\n  <g stroke-width=\"0\"/>\r\n  <g stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <path d=\"M18 9.25H6a.74.74 0 0 1-.69-.46.75.75 0 0 1 .16-.82l6-6a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 .16.82.74.74 0 0 1-.69.46Z\" />\r\n  <path d=\"M12 22.25a.74.74 0 0 1-.53-.22l-6-6a.75.75 0 0 1-.16-.82.74.74 0 0 1 .69-.46h12a.74.74 0 0 1 .69.46.75.75 0 0 1-.16.82l-6 6a.74.74 0 0 1-.53.22Z\" />\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/sortingArrow.6f294b50d6a4fc4ad828889c37b5ad72.svg"),
        {
          React: SvgSortingArrow,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      